/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Contact_EmailInputs */

const fr_about_contact_email = /** @type {(inputs: About_Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyez-moi un e-mail à`)
};

const en_about_contact_email = /** @type {(inputs: About_Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send me an email at`)
};

/**
* | output |
* | --- |
* | "Send me an email at" |
*
* @param {About_Contact_EmailInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const about_contact_email = /** @type {((inputs?: About_Contact_EmailInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Contact_EmailInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_about_contact_email(inputs)
	return en_about_contact_email(inputs)
});